import gql from "graphql-tag";

export const IMPORT_SECTION_OPTION_TYPE = gql`
  mutation ImportSectionOptType($filter: importCostumeType!) {
    importSectionOptType(filter: $filter) {
      id
      name
      costumeFeatures {
        id
        name
        costumeAttributes {
          id
          name
          costumeValues {
            id
            name
          }
        }
      }
    }
  }
`;
